import { userRole, type UserRole } from '@/lib/api/schemas';

import { AppRoutes } from '@/constants/routes';

export interface SidebarItem {
  title: string;
  value: string;
  icon: string;
  disabled?: boolean;
  roles: UserRole[];
  to?: string;
}

export const sidebarItems: SidebarItem[] = [
  {
    title: 'nav.notifications',
    value: 'notification',
    icon: 'ri:notification-2-line',
    to: AppRoutes.NOTIFICATIONS,
    roles: [userRole.Admin, userRole.Mandatary, userRole.LeadProvider],
  },
  {
    title: 'nav.contacts',
    value: 'contacts',
    icon: 'ri:contacts-line',
    to: AppRoutes.LEADS,
    roles: Object.values(userRole),
  },
  {
    title: 'nav.users',
    value: 'users',
    icon: 'ri:user-2-line',
    to: AppRoutes.USERS,
    roles: [userRole.Admin, userRole.Viewer],
  },
  {
    title: 'nav.leadProviderRequests',
    value: 'leadProviderRequests',
    icon: 'ri:file-list-2-line',
    to: AppRoutes.LEAD_PROVIDER_REQUESTS,
    roles: [userRole.Admin],
  },
  {
    title: 'nav.events',
    value: 'eventsAdmin',
    icon: 'ri:calendar-event-line',
    to: AppRoutes.ADMIN_EVENTS,
    roles: [userRole.Admin, userRole.Viewer],
  },
  {
    title: 'nav.events',
    value: 'eventsMandatary',
    icon: 'ri:calendar-event-fill',
    to: AppRoutes.MANDATARY_EVENTS,
    roles: [userRole.Mandatary],
  },
  {
    title: 'nav.commissions',
    value: 'commissions',
    icon: 'ri:money-euro-circle-line',
    to: AppRoutes.COMMISSION,
    roles: [userRole.LeadProvider],
  },
];

export const sidebarActions: SidebarItem[] = [
  {
    title: 'nav.help',
    icon: 'ri:question-line',
    value: 'guide',
    roles: [userRole.Mandatary, userRole.LeadProvider],
  },
  {
    title: 'nav.preferences',
    icon: 'ri:settings-3-line',
    value: 'preferences',
    roles: [userRole.Admin, userRole.Viewer],
    to: AppRoutes.PREFERENCES,
  },
];
